import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth token storage
let authToken = localStorage.getItem('bitarot_token');

export const setAuthToken = (token) => {
  authToken = token;
  if (token) {
    localStorage.setItem('bitarot_token', token);
  } else {
    localStorage.removeItem('bitarot_token');
  }
};

export const getAuthToken = () => authToken;

// API client with auth header
const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

// Auth APIs
export const register = async (email, username, password) => {
  const response = await axios.post(`${API}/auth/register`, {
    email,
    username,
    password,
  });
  return response.data;
};

export const login = async (email, password) => {
  const response = await axios.post(`${API}/auth/login`, {
    email,
    password,
  });
  return response.data;
};

export const getMe = async () => {
  const response = await apiClient.get('/auth/me');
  return response.data;
};

// Tarot APIs
export const getAllCards = async () => {
  const response = await axios.get(`${API}/cards`);
  return response.data;
};

export const getCard = async (cardId) => {
  const response = await axios.get(`${API}/cards/${cardId}`);
  return response.data;
};

// Reading APIs
export const createReading = async (question, spreadType) => {
  const response = await apiClient.post('/reading/create', {
    question,
    spread_type: spreadType,
  });
  return response.data;
};

export const getReadingHistory = async (limit = 20) => {
  const response = await apiClient.get(`/reading/history?limit=${limit}`);
  return response.data;
};

export const getReading = async (readingId) => {
  const response = await apiClient.get(`/reading/${readingId}`);
  return response.data;
};

// Daily Card API
export const getDailyCard = async () => {
  const response = await apiClient.get('/daily-card');
  return response.data;
};

// Subscription APIs
export const getSubscriptionTiers = async () => {
  const response = await axios.get(`${API}/subscription/tiers`);
  return response.data;
};

export const submitPayment = async (paymentData) => {
  const response = await apiClient.post('/subscription/payment-submit', paymentData);
  return response.data;
};

// Admin APIs
export const getAdminUsers = async () => {
  const response = await apiClient.get('/admin/users');
  return response.data;
};

export const getAdminPayments = async () => {
  const response = await apiClient.get('/admin/payment-submissions');
  return response.data;
};

export const activateSubscription = async (data) => {
  const response = await apiClient.post('/admin/activate-subscription', data);
  return response.data;
};

// Admin Password Reset API
export const adminResetPassword = async (userId, newPassword) => {
  const response = await apiClient.post('/admin/reset-password', {
    user_id: userId,
    new_password: newPassword
  });
  return response.data;
};

// Password Change API
export const changePassword = async (currentPassword, newPassword) => {
  const response = await apiClient.post('/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword
  });
  return response.data;
};
